/**
 * GlobalHistoryPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material-UI
import {withStyles} from "@material-ui/core";

// Material-UI components
import CircularProgress from '@material-ui/core/CircularProgress';

// application components
import HistoryTable from "./HistoryTable";
import WarningPanel from "../base/WarningPanel";

// application
import {fetchGlobalHistory} from "../../operations/history";


/**
 * GlobalHistoryPanel shows recent changes of all objects
 *
 * @author Jens Gruschel
 */
export class GlobalHistoryPanel extends React.Component {

    _isMounted = false;

    state = {
        waiting: false,
        disconnected: false,
        changes: []
    }

    componentDidMount() {
        this._isMounted = true;
        this.refresh();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.time !== prevProps.time) {
            this.refresh();
        }
    }

    refresh() {
        this.setState({
            waiting: true,
            disconnected: false,
            changes: []
        })
        this.fetchData();
    }

    async fetchData() {
        try {
            const changes = await fetchGlobalHistory(this.props.accessToken, this.props.types);
            if (this._isMounted) {
                this.setState({
                    waiting: false,
                    disconnected: false,
                    changes: changes
                });
                // otherwise this information is not important any more
                // (possibly meanwhile another query is running)
            }
        }
        catch (error) {
            if (this._isMounted) {
                this.setState({
                    waiting: false,
                    disconnected: true,
                    changes: []
                });
                // otherwise this information is not important any more
                // (possibly meanwhile another query is running)
            }
        }
    }

    render() {
        const { classes } = this.props;

        return <div className={classes.root}>
                {
                    this.state.waiting && <CircularProgress className={classes.progress} />
                }
                {
                    this.state.disconnected && <WarningPanel text="Verbindung zum Server unterbrochen!" />
                }
                {
                    this.state.changes.length > 0 && <HistoryTable
                        includeObjectInfo={true}
                        changes={this.state.changes}
                        onEdit={this.props.onEdit}
                        onUndo={this.props.onUndo}
                    />
                }
        </div>;
    }
}

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: 20,
        marginBottom: 20
    },
    progress: {
        display: "block",
        margin: "16px auto"
    }
});

GlobalHistoryPanel.propTypes = {
    time: PropTypes.string,
    onUndo: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        types: state.types,
        accessToken: state.authorization.accessToken
    };
}

export default connect(mapStateToProps)(withStyles(styles)(GlobalHistoryPanel));